<div
  class="gw-flex gw-items-center gw-justify-between gw-p-6 gw-border-b gw-border-border-normal"
>
  <h4
    class="gw-text-xl gw-font-semibold gw-text-text-primary"
    id="modal-basic-title"
  >
    {{ 'features.integrations.configureCredentials' | translate }}
  </h4>
</div>
<div class="gw-p-6">
  <p class="gw-text-sm gw-text-text-secondary gw-m-0 gw-mb-6">
    {{ 'features.integrations.sandbox.hint' | translate }}
  </p>

  <div class="gw-flex gw-justify-end gw-gap-3">
    <gatewee-button
      [title]="'common.actions.cancel' | translate"
      variant="secondary"
      (click)="close()"
    ></gatewee-button>
    <gatewee-button
      [title]="
        submitting
          ? ('common.actions.saving' | translate)
          : ('common.actions.save' | translate)
      "
      variant="primary"
      [disabled]="submitting"
      (click)="submit()"
    ></gatewee-button>
  </div>
</div>
